import { token } from '@atlaskit/tokens';

export const tickBoxClassName = 'media-card-tickbox';

export const tickboxFixedStyles: string = `
  background-color: ${token('color.background.input')};
  color: ${token('color.icon.subtle')};
`;
